import React from 'react';

/**
 * CustomTooltip - Reusable Recharts tooltip component
 *
 * Provides consistent tooltip styling matching the dashboard design.
 *
 * @param {boolean} active - Whether tooltip is active
 * @param {Array} payload - Data payload from Recharts
 * @param {string} label - X-axis label
 */
const CustomTooltip = ({ active, payload, label }) => {
  if (active && payload && payload.length) {
    return (
      <div className="bg-white p-3 border border-gray-200 rounded-lg shadow-lg">
        <p className="text-gray-700 font-medium mb-1">{label}</p>
        {payload.map((entry, index) => (
          <p key={index} style={{ color: entry.color }} className="text-sm mb-0">
            {entry.name}: {entry.value}
          </p>
        ))}
      </div>
    );
  }
  return null;
};

export default CustomTooltip;
